module.exports = __webpack_public_path__ + "static/media/home-hands.a7b14ffb.png";